import { render, staticRenderFns } from "./logisticsDetails.vue?vue&type=template&id=1f2404eb&scoped=true"
import script from "./logisticsDetails.vue?vue&type=script&lang=js"
export * from "./logisticsDetails.vue?vue&type=script&lang=js"
import style0 from "./logisticsDetails.vue?vue&type=style&index=0&id=1f2404eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2404eb",
  null
  
)

export default component.exports